import PropTypes from 'prop-types'
import { isTuxApp, isMobileOrTuxApp, isOLBApp } from '../../utils/browserutils'
import { NativeInterfaceHandler } from '../../utils/nativeHandlers'
import USBModal from '../modal-wrapper/index'

const AddBillError = (props) => {
  const { handleModalClose, errorCode, lang } = props
  const afTokenValue =
    typeof sessionStorage !== 'undefined' &&
    sessionStorage.getItem('AFTokenValue')
  let modalTitle
  let buttonLabel
  switch (errorCode) {
    case '409.1800.2804':
      modalTitle = lang?.ADDRESS_TITLE
      buttonLabel = lang?.ADDRESS_BTN
      break
    case '409.1800.2805':
    case '400.1003.2012':
      modalTitle = lang?.EMAIL_TITLE
      buttonLabel = lang?.EMAIL_BTN
      break
    case '409.1800.2806':
      modalTitle = lang?.PHONE_TITLE
      buttonLabel = lang?.PHONE_BTN
      break
    default:
      modalTitle = ''
      buttonLabel = ''
  }

  const onProfileClick = () => {
    if (isTuxApp()) {
      if (
        typeof window !== 'undefined' &&
        typeof window.parent.BillPayRedesignNavigation === 'function'
      ) {
        window.parent.BillPayRedesignNavigation('MyProfile')
      }
    } else if (isOLBApp()) {
      window.location.assign(
        `${window.location.origin}/USB/${afTokenValue}/MyProfileDashboard/MyProfileDashboardIndex`
      )
    } else {
      NativeInterfaceHandler('UpdateProfile', false)
    }
  }

  return (
    <USBModal
      id="missing-customer-info-modal"
      isOpen
      handleModalClose={handleModalClose}
      zIndex="1050"
      wrapID={isMobileOrTuxApp() && 'readytosend-popup-modal'}
      tag="h1"
      addClasses="small-modal"
      modalTitle={modalTitle}
      footerButtonOptions={[
        {
          type: 'primary',
          id: 'go-to-profile-btn',
          text: buttonLabel,
          clickEvent: onProfileClick
        },
        {
          type: 'secondary',
          id: 'error-cancel-btn',
          text: lang?.CANCEL,
          clickEvent: handleModalClose
        }
      ]}
    />
  )
}

AddBillError.propTypes = {
  handleModalClose: PropTypes.func,
  errorCode: PropTypes.string,
  lang: PropTypes.string
}

AddBillError.defaultProps = {
  handleModalClose: () => false,
  errorCode: '',
  lang: ''
}

export default AddBillError
